import React from 'react';
import classNames from 'classnames';
import { TitleDivider } from '../title-divider';
import { RichText } from '../rich-text';
import { Button } from '../button';
import { Link } from 'gatsby';

export class ContentIntro extends React.Component {
  constructor (props) {
    super(props);
    this.state = {};
  }

  get className () {
    return classNames({
      'content-intro': true,
      'content-intro--has-eyebrow': this.props.titleBar,
      'content-intro--has-cta': this.props.button
    })
  }

  render () {
    return (
      <>
        { this.props.titleBar && <TitleDivider>{ this.props.titleBar }</TitleDivider> }
        <section className={this.className}>
          <div className="content-intro__text">
            <RichText document={ this.props.content } />
          </div>
          { this.props.button && (
            <div className="content-intro__button">
              <Link className="button" to={this.props.buttonTarget.slug}>{ this.props.button }</Link> 
            </div>
          )}
        </section>
      </>
    );
  }
}
